<template>
    <div
        :data-component-name="$options.name"
    >
        <div class="accommodations-list" v-bind:key="index" v-for="(assignment, index) in assignmentsList">
            <!-- <pre>{{ assignment }}</pre> -->
            <q-field dense filled label="">
                <template v-slot:control>
                    <div class="profession label-style row q-mb-lg"
                        v-if="!assignmentsList[index - 1] || (assignmentsList[index - 1].profession.name != assignment.profession.name)">
                        <div class="col">
                            {{ assignment.profession.name }}
                        </div>
                    </div>
                    <div class="input-style row items-center full-width">
                        {{  assignment.assignedTo.name }}
                        <UserProfileInfo :userProfile="assignment.assignedTo" class="q-ml-sm" :size="'16px'" />
                        <div class="row q-ml-auto">
                            <label class="row" v-if="assignment.accommodation_not_required || focused == assignment.id">
                                Hébergement non requis
                                <input type="checkbox" class="q-ml-sm" v-model="assignment.accommodation_not_required">
                            </label>
                            <label @click="focused = assignment.id" v-if="!assignment.accommodation_not_required">
                                <span v-if="focused!=assignment.id && assignment.accommodation_room_number && assignment.accommodation_room_number!=''">
                                    Chambre #{{ assignment.accommodation_room_number }}
                                </span>
                                <span v-else-if="focused!=assignment.id && (!assignment.accommodation_room_number || assignment.accommodation_room_number!='')" class="text-red">
                                    Entrez le numéro de chambre
                                </span>
                                <input ref="'input'+assignment.id" v-show="focused==assignment.id" class="q-ml-md room-number" type="text" autofocus v-model="assignment.accommodation_room_number" placeholder="no de chambre"
                                    @blur="setBlur(assignment.id)">
                            </label>
                        </div>
                    </div>
                </template>
            </q-field>
        </div>
    </div>
</template>

<script>
    import orderBy from "lodash/orderBy";

    export default {
        name: 'AssignmentsAccommodationList',
        props: [
            "assignments",
            "variables",
            "projectAssignmentWithError",
            "accessLevel"
        ],
        data(){
            return {
                setValueTO: null,
                selectTO: null,
                focused: []
                // assignmentsCount: {}
            }
        },
        mounted() {

        },
        methods: {
            emitErrors() {
                let hasError = 0
                let accommodatedAssignment = 0

                this.assignmentsList.forEach(item => {
                    if (!item.accommodation_not_required && (!item.accommodation_room_number || item.accommodation_room_number == '')) {
                        hasError++
                    } else {
                        accommodatedAssignment++
                    }
                })

                this.$emit('accommodations-errors', {
                    errorCount: hasError,
                    sucessCount: accommodatedAssignment
                })
            },
            setBlur(assignmentId) {
                setTimeout(() => {
                    if(this.focused== assignmentId) this.focused=null
                }, 200)
            },
            setFocus(event, assignement/*, value*/){
                clearTimeout(this.selectTO);
                this.selectTO=setTimeout(function(){
                    event.target.select();
                }, 100);

                this.focused=assignement.profession.id;
            },
            setValue(event, assignment, count){
                let value=event.target.value;
                if(value>100) value=100;
                clearTimeout(this.setValueTO)
                this.setValueTO=setTimeout(function(){
                    this.$emit('set-assignments-count', { profession: {id: assignment.profession.id, name: assignment.profession.name}, value: parseInt(value)-parseInt(count) } )
                }.bind(this), 500)
            }
        },
        watch: {
            assignmentsList: function () {
                this.emitErrors()
            }
        },
        computed: {
            assignmentsCount(){
                let assignmentsCount={};
                this.assignments.forEach(function(assignment){
                    if(!assignmentsCount[assignment.profession.id]) assignmentsCount[assignment.profession.id]={count: 0, assignedCount: 0};
                    assignmentsCount[assignment.profession.id].count++;
                    if(assignment.assignedTo) assignmentsCount[assignment.profession.id].assignedCount++;
                    assignmentsCount[assignment.profession.id].value=assignmentsCount[assignment.profession.id].assignedCount+' / '+assignmentsCount[assignment.profession.id].count;
                    if(this.focused==assignment.profession.id) assignmentsCount[assignment.profession.id].value=assignmentsCount[assignment.profession.id].count;
                }.bind(this))
                return assignmentsCount;
            },
            assignmentsList(){
                if(!this.assignments || this.assignments.length==0) return [];
                return orderBy(this.assignments, [item => item.profession.name.toLowerCase()], ['asc'])
            },

            // hasError() {
            //     return hasError
            // }
        }
    }
</script>

<style lang="scss" scoped>

    .assignment {
        // font-size: 12px;
        // line-height: 24px;

        // border-bottom: 1px solid grey
    }


    .room-number {
        margin-right: -4px;
        padding: 0px 4px;
        text-align: right;
        width: 100px;
        line-height: 1.8;
    }

</style>